import { Button, Image } from "antd-mobile";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { DownOutline } from "antd-mobile-icons";
import { CurrencyChanger } from "../../../../components";

import { useAuth } from "../../../../context/AuthContext";
import { useGetUserInfo } from "../../../../hooks/userinfo.hooks";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { envChangeType } from "../../../../plugins/utils";
import { useGetAgentBalance } from "../../../Personal/hooks/personal.hook";
import TransferPopup from "./components/TransferPopup";
import styles from "./style.module.scss";

function BalanceArea({
  balanceAreaContainerStyle = "",
  showLevelBadge = true,
  showWalletImage = false,
}) {
  const [showTransferPopup, setShowTransferPopup] = useState(false);
  const [showCurrencyChanger, setShowCurrencyChanger] = useState(false);
  const { defaultCurrency } = useAuth();
  const { t } = useTranslation();

  const { data: userInfo } = useGetUserInfo({
    enabled: showLevelBadge,
  });
  const { data: balance } = useGetAgentBalance({});
  const onChangeCurrency = () => {
    setShowCurrencyChanger(true);
  };

  return (
    <div
      style={{
        backgroundImage: "url('/images/personal/balanceBg.png')",
      }}
      className={`${styles.balanceArea} ${balanceAreaContainerStyle}`}
    >
      <div className={styles.leftContainer}>
        {showWalletImage ? <Image className={styles.img} src={"/images/home/wallet.png"} /> : null}
        <div className={styles.bonusGroup}>
          <div className={styles.titleContainer}>
            <div className={styles.title}>{t("mobile.personal.balance")}</div>
            <div onClick={onChangeCurrency} className={styles.changeCurrencyContainer}>
              <div className={styles.currencyText}>{(balance && balance[0]?.currency) ?? " "}</div>
              <DownOutline className={styles.icon} />
            </div>
            {showLevelBadge && userInfo ? (
              <Image
                className={styles.badge}
                src={`/images/comission/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/levels/text_LV${userInfo.agent_rebate_level_id}.png`}
                fallback={
                  <Image
                    src={`/images/comission/default/levels/text_LV${userInfo.agent_rebate_level_id}.png`}
                    placeholder={false}
                  />
                }
              />
            ) : null}
          </div>

          <div className={styles.money}>{`${t(
            `global.currency.${defaultCurrency?.toUpperCase()}`,
          )} ${(balance && balance.length > 0 && moneyFormat(balance[0]?.money)) || "-"}`}</div>
        </div>
      </div>

      <div className={styles.btnBox}>
        <Button
          fill="none"
          shape="rounded"
          color="primary"
          className={styles.btn}
          onClick={() => setShowTransferPopup(true)}
          disabled={!balance || balance[0]?.money < 1}
        >
          {t("mobile.personal.transfer")}
        </Button>
      </div>
      <TransferPopup
        // visible={true}
        visible={showTransferPopup}
        onMaskClick={() => {
          setShowTransferPopup(false);
        }}
        userWallet={balance}
        onClose={() => {
          setShowTransferPopup(false);
        }}
      />
      <CurrencyChanger
        visible={showCurrencyChanger}
        onClose={() => {
          setShowCurrencyChanger(false);
        }}
      />
    </div>
  );
}

export default BalanceArea;
